import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useLazyQuery } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { GET_AVAILABILITY_STORES_NEARBY } from '../../queries/get-availability-stores-nearby.js';
import { fromAvailabilityStoresNearbyQueryToStore } from './adapters/fromAvailabilityStoresNearbyQueryToStore.js';

const useAvailabilityStoresNearby = (variables)=>{
    const { locale  } = useIntl();
    const [query, queryState] = useLazyQuery(GET_AVAILABILITY_STORES_NEARBY, {
        variables: variables !== null && variables !== void 0 ? variables : undefined,
        context: {
            forwardHeaders: {
                'Accept-Language': locale
            }
        },
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
        onError (error) {
            console.error('Failed to fetch data for useAvailabilityStoresNearby: ', error);
        }
    });
    var _data;
    const { availabilityStoresNearby  } = (_data = queryState.data) !== null && _data !== void 0 ? _data : {};
    const data = React.useMemo(()=>fromAvailabilityStoresNearbyQueryToStore(availabilityStoresNearby)
    , [
        availabilityStoresNearby
    ]);
    return React.useMemo(()=>[
            query,
            swcHelpers.objectSpread({}, queryState, {
                data
            })
        ]
    , [
        data,
        queryState,
        query
    ]);
};

export { useAvailabilityStoresNearby as default, useAvailabilityStoresNearby };
//# sourceMappingURL=use-availability-stores-nearby.js.map
